import { render } from "./dwhs.vue?vue&type=template&id=f0bdd0f0&scoped=true"
import script from "./dwhs.vue?vue&type=script&lang=js"
export * from "./dwhs.vue?vue&type=script&lang=js"

import "./dwhs.vue?vue&type=style&index=0&id=f0bdd0f0&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bdd0f0"]])

export default __exports__